import { WidgetFullScreenComponent } from '../widget-full-screen-component';
import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { GenericServiceResponse, ToastMessageService } from '@nts/std';
import { WidgetEmptyGaugeValue } from '../../../domain-models/dto/widget-empty-gauge-value-dto';
import { ColorType } from 'highcharts';
import { Observable, map, of, tap } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DashBoardItemViewModel } from 'src/app/dash-board/view-models/dash-board-item.view-model';

import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import HC_boost from 'highcharts/modules/boost';
import HC_noDataToDisplay from 'highcharts/modules/no-data-to-display';
import HC_more from 'highcharts/highcharts-more';
import HC_solidGauge from 'highcharts/modules/solid-gauge';
import { NgIf } from '@angular/common';

HC_boost(Highcharts);
HC_noDataToDisplay(Highcharts);
HC_more(Highcharts);
HC_solidGauge(Highcharts);

@UntilDestroy()
@Component({
    selector: 'nts-empty-gauge-widget',
    templateUrl: './empty-gauge-widget.component.html',
    styleUrls: ['./empty-gauge-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        HighchartsChartModule,
        NgIf
    ]
})

// tslint:disable-next-line: max-line-length
export class EmptyGaugeWidgetComponent extends WidgetFullScreenComponent implements OnInit {
    @ViewChild('chartContainer') chartContainer: ElementRef;

    chart: Highcharts.Chart;
    chartOptions: Highcharts.Options;
    Highcharts: typeof Highcharts = Highcharts;
    title: string;
    subTitle: string;
    /*
    -- LifeCycle --
    ngOnInit
        -> initChart ( va fatta sempre nella OnInit)!
    logChartInstance -> qui hoi il grafico
    initialize  -> qui posso caricare i dati
    ngAfterViewInit
    */

    constructor(private cd: ChangeDetectorRef, toastMessageService: ToastMessageService) {
        super(toastMessageService, cd);
    }

    protected getLoadDataObservable<WidgetEmptyGaugeValue>(refreshigData: boolean): Observable<GenericServiceResponse<WidgetEmptyGaugeValue>> {
        const widgetDataArg = this.getWidgetDataArg();
        return this.getApiClient().getEmptyGaugeWidgetValue(widgetDataArg, refreshigData).pipe(tap((r) => this.lastUpdate = r.cache?.timestamp), map(r => r.response)) as any;
    }

    protected initView(result: WidgetEmptyGaugeValue): Observable<boolean> {

        this.title = result.title;
        this.modalTitle = result.title;
        this.subTitle = result.subTitle;

        const minValue = result.minValue;
        const maxValue = result.maxValue;
        const value = result.currentValue;
        const serieName = result.serieName;
        const firstLimit = (result.firstLimit - minValue) / (maxValue - minValue);
        const secondLimit = (result.secondLimit - minValue) / (maxValue - minValue);

        const statusValue: [number, ColorType][] = [
            [0, '#DF5353'],          // red
            [firstLimit, '#DDDF0D'], // yellow
            [secondLimit, '#55BF3B'] // green
        ];

        // aggiorno il grafico
        this.chart.update({
            yAxis: {
                stops: statusValue,
                min: minValue,
                max: maxValue
            },
            series: [{
                name: serieName,
                type: 'solidgauge',
                data: [
                    value
                ],
                dataLabels: {
                    format:
                        '<div style="text-align:center">' +
                        '<span style="font-size:25px">{y}</span><br/>' +
                        '<span style="font-size:12px;opacity:0.4">' + serieName + '</span>' +
                        '</div>'
                },
                tooltip: {
                    valueSuffix: serieName
                }
            }]
        }, true, true, true);

        // la prima volta devo effettuar eil timeout per il disegno corretto del grafico dentro il content
        setTimeout(() => {
            this.resizeChanged(null);
        });

        this.cd.detectChanges();

        return of(true);
    }

    ngOnInit() {
        this.initChart();
    }

    initChart() {
        // parametri default
        this.chartOptions = {
            chart: {
                type: 'solidgauge'
            },
            title: '' as any,
            pane: {
                center: ['50%', '85%'],
                size: '120%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor:
                        Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                } as any
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            // the value axis
            yAxis: {
                lineWidth: 0,
                tickWidth: 0,
                minorTickInterval: null,
                tickAmount: 2,
                title: {
                    y: -70,
                },
                labels: {
                    y: 16
                },
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: 5,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            },
            /*responsive: {
                rules: [{
                    condition: {
                        minH: 500
                    },
                    chartOptions: {
                        yAxis: {
                            title: {
                                y: 0,
                                //text: 'RAM'
                            }
                        }
                    }
                }]
            }*/
        };
    }

    logChartInstance(chart: Highcharts.Chart) {
        this.chart = chart;
    }

    override resizeChanged(dashboardItemVm: DashBoardItemViewModel) {
        super.resizeChanged(dashboardItemVm);
        if (this.chart) {
            this.chart.setSize(this.chartContainer.nativeElement.offsetWidth, this.chartContainer.nativeElement.offsetHeight, true);
        }
    }
}

